import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import { STATUS } from './constants'

export const filterClockPictures = (
  clockPictures: ClockPicture[],
  status: string
): ClockPicture[] => {
  let isValid: boolean
  let isInValid: boolean
  let clockIn: boolean
  let clockOut: boolean

  switch (status) {
    case STATUS.isValid:
      isValid = true
      break

    case STATUS.isInValid:
      isInValid = true
      break

    case STATUS.isClockedIn:
      clockIn = true
      break

    case STATUS.isClockedOut:
      clockOut = true
      break

    default: // do nothing
  }

  return clockPictures.filter((clockPicture: ClockPicture) => {
    if (isValid) return !clockPicture.isInvalid

    if (isInValid) return clockPicture.isInvalid

    if (clockIn) return clockPicture.clockedIn

    if (clockOut) return clockPicture.clockedOut

    return true
  })
}
